import { CIInfoIcon, CILabel } from 'ccs-ui-components';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FORM_SERVICE_TYPE } from '../../../../../../../constants/ServiceConstants';
import {
  IHeaderParam,
  IServiceOperationValidationModel
} from '../../../../../../../models';
import { useSelector } from '../../../../../../../store/AppStore';
import MQHeaderParam from '../mq-header-param/MQHeaderParam';
import ServiceOperationHeaderItem from '../param-item/ServiceOpsHeaderItem';
import classes from './HeaderItemWrapper.module.scss';
import HeaderParamField from './HeaderParamField';

interface IHeaderItemWrapperProps {
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  serviceOpsFormData: IServiceOperationValidationModel;
  onAddHeaderHandler: () => void;
  headerParamList: IHeaderParam[];
  isEditOrCreate: boolean;
  onHeaderItemChange: (obj: IHeaderParam) => void;
  onHeaderItemDelete: (index: number) => void;
  shouldDisplayHeaderParam: () => boolean;
  shouldDisplayQueryParam: () => boolean;
  updateHeaderParamList: (headerParamsItem: IHeaderParam[]) => void;
}
const HeaderItemWrapper = ({
  handleInputChange,
  serviceOpsFormData,
  onAddHeaderHandler,
  headerParamList,
  isEditOrCreate,
  onHeaderItemChange,
  onHeaderItemDelete,
  shouldDisplayQueryParam,
  shouldDisplayHeaderParam,
  updateHeaderParamList
}: IHeaderItemWrapperProps) => {
  const { t: translate } = useTranslation();
  const { serviceType } = useSelector((state) => state.serviceDetailsReducer);

  return (
    <Form.Group className={shouldDisplayHeaderParam() && !shouldDisplayQueryParam() ? 'py-3' : 'pb-3'}>
      <CILabel id="headerParamKey" labelText={translate('service_operation_form.service_header_param')} infoIconText={translate('service_operation_form.header_param_info_bubble')} />
      <Row className={classes['param-container']}>
        <Row className={classes['param-header']}>
          <Col sm={5}>
            {translate('service_operation_form.param_key')}
            <CIInfoIcon iconTxt={String(translate('service_operation_form.header_param_key_info_bubble'))} />
          </Col>
          <Col sm={6} className={classes['value-header']}>
            {translate('service_operation_form.param_value')}
            <CIInfoIcon iconTxt={String(translate('service_operation_form.header_param_value_info_bubble'))} />
          </Col>
        </Row>
        {!isEditOrCreate
          && (!headerParamList
            || headerParamList?.length < 1
            || headerParamList === null) && (
            <Row className={classes['no-records']}>
              {translate('service_operation_form.no_records_header')}
            </Row>
          )}
        {isEditOrCreate
          && serviceType?.toLocaleLowerCase() !== FORM_SERVICE_TYPE.MQ && (
            <HeaderParamField
              handleInputChange={handleInputChange}
              serviceOpsFormData={serviceOpsFormData}
              onAddHeaderHandler={onAddHeaderHandler}
            />
          )}
        {serviceType?.toLocaleLowerCase() === FORM_SERVICE_TYPE.MQ && (
          <Row className={classes['param-body']}>
            <MQHeaderParam
              updateHeaderParamList={updateHeaderParamList}
              headerParamListItem={headerParamList}
            />
          </Row>
        )}
        {serviceType?.toLocaleLowerCase() !== FORM_SERVICE_TYPE.MQ
          && headerParamList?.length >= 1
          && headerParamList.map((headerItem, index) => (
            <ServiceOperationHeaderItem
              index={index}
              key={headerItem.key}
              headerParamKey={headerItem.key}
              value={headerItem.value}
              isEdit={headerItem.isEdit}
              isView={!isEditOrCreate}
              updateHeader={onHeaderItemChange}
              deleteHeader={onHeaderItemDelete}
              headerList={headerParamList}
            />
          ))}
      </Row>
    </Form.Group>
  );
};

export default HeaderItemWrapper;
